import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ModalComponent } from '../../modal/modal.component';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ActionPlanService } from '../../shared/services/index';
import * as _ from 'lodash';

@Component({
    selector: 'item-status-edit',
    templateUrl: './item-status-edit.component.html',
    standalone: false
})
export class ActionPlanItemStatusEditPageComponent extends BaseModalPageComponent implements OnInit {
  public actionPlanId: string;
  public actionPlanItemId: string;
  public statuses: any;
  public processing: boolean = false;
  public status: number;

  @ViewChild('statusModal', { static: true }) actionModal: ModalComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ActionPlanService,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const actionPlanId = params['actionPlanId'];
      if (actionPlanId == null) this.router.navigate([this.actionPlansRoute]);

      this.actionPlanId = actionPlanId;

      const actionPlanItemId = params['actionPlanItemId'];
      if (actionPlanItemId == null) this.router.navigate([this.actionPlansRoute, this.actionPlanId]);

      this.actionPlanItemId = actionPlanItemId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service.updateActionPlanItemStatus(this.actionPlanId, this.actionPlanItemId, this.status).subscribe((res) => {
      this.goToBack();
      this.processing = false;
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.statuses = this.service.getActionPlanItemStatus();

    this.service.getActionPlanItem(this.actionPlanId, this.actionPlanItemId).subscribe((data) => {
      this.status = data.status;
    });
  }

  public openStatusSelector(): void {
    this.openSelector(this.actionModal, this.statuses, this.status);
  }

  public selectStatusMenu(item: any) {
    this.status = item.selectedIndex;
  }

  public onClose(e: any) {}
}
